import React from "react";
import "./containerSettings.scss";

import CustomDialog from "../../../../components/customDialog/CustomDialog";

import EastIcon from "@mui/icons-material/East";

import { Stack } from "react-bootstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import NotificationToggle from "../notificationToggle/NotificationToggle";

const ContainerSettings = ({ list }) => {
  return (
    <Stack className="box-settings" gap={1}>
      {list
        ? list.map((item) => {
            if (item.customDialog)
              return (
                <CustomDialog
                  key={item.id}
                  title={t("settings.modal_delete_account.title")}
                  body={t("settings.modal_delete_account.body")}
                  textClose={t("common.cancel")}
                  textCallToAction={t("common.confirm")}
                  trigger={
                    <SingleItem
                      arrow={item.arrow}
                      customDialog={item.customDialog}
                      id={item.id}
                      value={item.value}
                      path={item.path}
                      IconMenu={item.icon}
                      red={item.red}
                    />
                  }
                  callback={() => {
                    item.function();
                  }}
                />
              );
            else if (item.banner_notification)
              return (
                <NotificationToggle
                  key={item.id}
                  IconMenu={item.icon}
                  value={item.value}
                />
              );
            else
              return (
                <SingleItem
                  key={item.id}
                  arrow={item.arrow}
                  customDialog={item.customDialog}
                  id={item.id}
                  value={item.value}
                  path={item.path}
                  IconMenu={item.icon}
                  red={item.red}
                  handleClick={item.function}
                />
              );
          })
        : null}
    </Stack>
  );
};

const SingleItem = ({
  id,
  value,
  IconMenu,
  path,
  arrow,
  red,
  handleClick = null,
  onClick,
}) => {
  const navigate = useNavigate();

  return (
    <div className="container-single-item-settings">
      <Stack
        direction="horizontal"
        className="single-item-settings"
        onClick={(e) => {
          if (onClick) onClick(e); // Permette di attivare il CustomDialog
          else {
            if (handleClick) handleClick();
            if (path) navigate(path);
          }
        }}
      >
        <div>
          {IconMenu ? (
            <IconMenu
              className="single-item-icon"
              style={{ color: red ? "#DD0707" : null }}
            />
          ) : null}
          {value ? (
            <span
              className="single-item-value"
              style={{ color: red ? "#DD0707" : null }}
            >
              {t(value)}
            </span>
          ) : null}
        </div>
        {arrow ? <EastIcon /> : <div>{null}</div>}
      </Stack>
      <hr />
    </div>
  );
};

export default ContainerSettings;
